import blackFriday, { blackFridayBody } from './black-friday';
import contrast, { contrastBody } from './contrast';

const data = {
  'black-friday': {
    title: 'black-friday',
    styles: blackFriday,
    bodyStyle: blackFridayBody
  },
  contrast: {
    title: 'contrast',
    styles: contrast,
    bodyStyle: contrastBody
  }
}

export default data
